module.exports = __webpack_public_path__ + "static/media/voxwizard-5.b33e21fa.jpg";